import React, { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useLocation } from "react-router-dom";
import Repo from "../../Utility/Repo";
import { TokenContext } from "../../Components/TokenContext";
import ModalComponent from "../../Components/ModalComponent";
import configuration from "../../Utility/config.json";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ViewAnnouncements(props) {
  const apiToken = useContext(TokenContext);
  let query = useQuery();
  const [session, setSession] = useState({});
  const [isOpen, toggleModal] = useState(false);
  const auth_url = process.env.REACT_APP_AUTH_URL;
  const entity_url = process.env.REACT_APP_ENTITY_URL;

  const queryParameters = entity_url + "&returnUrl=" + window.location;

  useEffect(() => {
    if (query.get("id")) {
      Repo.getSessionByIdUser(apiToken, query.get("id"))
        .then((response) => {
          if (response.status == 200) {
            setSession(response.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  const login = () => {
    window.location.href =
      auth_url + configuration.AUTH_PATH_LOGIN + queryParameters;
  };

  return (
    <>
      <div className="row mb-3">
        <div className="col-lg-9">
          <h4>{session && session.name} </h4>
        </div>
      </div>
      <div className="card-wrapper card-space col-lg-12">
        <div className="card card-bg card-big roundedCustom no-after">
          <div className="card-body">
            {session ? (
              <>
                <div className="row">
                  {session.service && (
                    <>
                      <div className="col-lg-4">
                        Riferimento:&nbsp; <b>{session.service.name} </b>
                      </div>
                    </>
                  )}
                </div>
                {session.service && (
                  <div className="row mt-3">
                    <div className="col-lg-12">
                      <p>{session.service.description}</p>
                    </div>
                  </div>
                )}

                <hr className="pb-4" />
                <h5 className="mt-4">
                  <b>Fasce ISEE</b>
                </h5>
                {session.bands && session.bands.length > 0 ? (
                  <>
                    <div className="it-list-wrapper mt-4">
                      <ul className="it-list">
                        {session.bands.map((x, index) => (
                          <li key={index}>
                            <a
                              className="ancorList"
                              style={{ textDecoration: "none", color: "black" }}
                            >
                              <div className="it-right-zone m-0">
                                <div className="col">{x.name}</div>
                                <div className="col">
                                  <b>Minimo: </b>
                                  {x.min &&
                                    parseFloat(x.min).toLocaleString("it-IT")}
                                  &nbsp;€
                                </div>
                                <div className="col">
                                  <b>Massimo: </b>
                                  {x.max &&
                                    parseFloat(x.max).toLocaleString("it-IT")}
                                  &nbsp;€
                                </div>
                                <div className="col">
                                  <b>Percentuale: </b>
                                  {x.percent + "%"}
                                </div>
                                <div className="col">
                                  <b>Costo: </b>
                                  {x.fixedCost &&
                                    parseFloat(x.fixedCost).toLocaleString(
                                      "it-IT"
                                    )}
                                  &nbsp;€
                                </div>
                              </div>
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </>
                ) : (
                  <span className="text mt-3">
                    Non sono presenti fasce ISEE.
                  </span>
                )}
              </>
            ) : (
              <>
                <span className="text">
                  L' intervento selezionata non è presente.
                </span>
              </>
            )}
          </div>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Iscrizione intervento"
        body={
          "Per iscriversi all' intervento scelto è necessario effettuare il login. In seguito potrai visualizzare anche i file caricati dal comune."
        }
        buttonConfirm="Effettua Login"
        buttonDeny="Annulla"
        function={() => login()}
      ></ModalComponent>
    </>
  );
}

export default ViewAnnouncements;
